'use client';

import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface FilterBarProps {
  selectedIndustry: string;
  onIndustryChange: (industry: string) => void;
  selectedType: string;
  onTypeChange: (type: string) => void;
}

const FilterBar: React.FC<FilterBarProps> = ({
  selectedIndustry,
  onIndustryChange,
  selectedType,
  onTypeChange,
}) => {
  const industries = ['All Industries', 'Logistics', 'Environmental', 'Oil & Gas', 'Telecommunications'];
  const types = ['All Types', 'Leadership', 'Management', 'Technical'];

  const getIndustryColor = (industry: string) => {
    switch (industry) {
      case 'Logistics':
        return 'bg-teal-100 text-teal-800 border-teal-300 hover:bg-teal-200';
      case 'Environmental':
        return 'bg-green-100 text-green-800 border-green-300 hover:bg-green-200';
      case 'Oil & Gas':
        return 'bg-amber-100 text-amber-800 border-amber-300 hover:bg-amber-200';
      case 'Telecommunications':
        return 'bg-indigo-100 text-indigo-800 border-indigo-300 hover:bg-indigo-200';
      default:
        return 'bg-gray-100 text-gray-800 border-gray-300 hover:bg-gray-200';
    }
  };

  const getTypeColor = (type: string) => {
    switch (type) {
      case 'Leadership':
        return 'bg-purple-100 text-purple-800 border-purple-300 hover:bg-purple-200';
      case 'Management':
        return 'bg-blue-100 text-blue-800 border-blue-300 hover:bg-blue-200';
      case 'Technical':
        return 'bg-orange-100 text-orange-800 border-orange-300 hover:bg-orange-200';
      default:
        return 'bg-gray-100 text-gray-800 border-gray-300 hover:bg-gray-200';
    }
  };

  return (
    <div className="bg-card border border-border rounded-xl p-6 shadow-subtle">
      <div className="flex items-center gap-2 mb-4">
        <Icon name="FunnelIcon" size={20} className="text-primary" />
        <h3 className="text-lg font-heading font-bold text-foreground">
          Filter Experience
        </h3>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-semibold text-text-secondary mb-2">
            Industry
          </label>
          <div className="flex flex-wrap gap-2">
            {industries.map((industry) => (
              <button
                key={industry}
                onClick={() => onIndustryChange(industry)}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-300 border ${
                  selectedIndustry === industry
                    ? 'ring-2 ring-primary shadow-subtle font-bold'
                    : ''
                } ${getIndustryColor(industry)}`}
              >
                {industry}
              </button>
            ))}
          </div>
        </div>

        <div>
          <label className="block text-sm font-semibold text-text-secondary mb-2">
            Role Type
          </label>
          <div className="flex flex-wrap gap-2">
            {types.map((type) => (
              <button
                key={type}
                onClick={() => onTypeChange(type)}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-300 border ${
                  selectedType === type
                    ? 'ring-2 ring-primary shadow-subtle font-bold'
                    : ''
                } ${getTypeColor(type)}`}
              >
                {type}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterBar;